module.exports = __webpack_public_path__ + "static/img/tcBg.f055d69.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tcBg.png
// module id = gRox
// module chunks = 101